module.exports = __webpack_public_path__ + "img/AddToCalendarWhite.4c341f34.png";